/**
 * Fullscreen Burger Navigation
 * -------------------------------------------------- */

//open/close responsive navigation
$("#js-menu-toggle").on("click", function (e) {
  e.preventDefault();
  e.stopPropagation();

  var $trigger = $(this);

  $("#js-menu").toggleClass("is-visible");
  $("body").toggleClass("menu-is-visible");

  // Burger Animation
  $trigger.toggleClass("is-open");
  if (!$trigger.hasClass("is-open")) {
    $trigger.addClass("is-closing");
    setTimeout(function () {
      $trigger.removeClass("is-closing");
    }, 350);
  }

  //close overlay wih esc-key
  $(document).keydown(function (es) {
    if ($("#js-menu-toggle").hasClass("is-open") && es.which == 27) {
      $("#js-menu-toggle").trigger("click");
    }
  });
});



/**
 * WP Simple Subnav Toggler
 * -------------------------------------------------- */

$(".l-header__nav .sub-menu").removeClass("is-open").slideUp();
$('.l-header__nav .menu-item-has-children a').removeClass('arrow-down');

$(".l-header__nav .menu-item-has-children > a").on("click", function (e) {
  e.preventDefault();
  e.stopPropagation();

  var clickedMenu = $(this).next(".l-header__nav .sub-menu");
  var openMenu = $(".l-header__nav .sub-menu.is-open");
  var subisopen = clickedMenu.parents('li').children('a');

  if (clickedMenu.hasClass("is-open")) {
    clickedMenu
      .removeClass("is-open")
      .addClass("is-closed")
      .slideUp(220, "linear");
    subisopen
      .removeClass('arrow-down');
  } else {
    openMenu
      .slideUp(220, "linear")
      .removeClass("is-open")
      .addClass("is-closed");
    clickedMenu
      .removeClass("is-closed")
      .addClass("is-open")
      .slideDown(220, "linear");
    subisopen
      .addClass('arrow-down');
  }
});

// Close it when clicked outside
$(document).on('click', function (e) {
  if ($('.l-header__nav .sub-menu').hasClass('is-open')) {
    if (!$(e.target).closest('.l-header__nav .sub-menu').length) {
      $('.l-header__nav .sub-menu').removeClass('is-open').slideUp();
      $('.l-header__nav .menu-item-has-children a').removeClass('arrow-down');
    }
  }
})

// Close it when pressed esc-key
$(document).keydown(function (e) {
  if ($('.l-header__nav .sub-menu').hasClass('is-open') && e.which == 27) {
    $('.l-header__nav .sub-menu').removeClass('is-open').slideUp();
    $('.l-header__nav .menu-item-has-children a').removeClass('arrow-down');
  }
})